export default {
  data() {
    return {}
  },
  watch: {
    selectedColumns: {
      handler(newValue) {
        localStorage.setItem(this.selectedColumnsStore, JSON.stringify(newValue));
      },
      deep: true
    }
  },
  created() {
    const storedColumns = localStorage.getItem(this.selectedColumnsStore);
    if (storedColumns) {
      this.selectedColumns = JSON.parse(storedColumns);
    }
  },
}  